// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleLookUp.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import AddRolePopup from './Izenda.AddRolePopup';
import Validator from 'share/components/hoc/Izenda.Validator';
import Select from 'share/components/controls/multiSelectBox/Izenda.Select';

const ValidatorSelect = Validator()(Select);

@connect()
export default class RoleLookUp extends Component {

  openRolePopup = () => {
    const props = this.props;

    props.openPopup(AddRolePopup, {
      onChange: props.onChangeFromPopup,
      loadRoles: props.loadRoles,
      roleOption: props.roleOption
    })
  };

  render() {
    const props = this.props;
    const { localization } = props;

    return (
      <div className="izenda-Recipient-Container">
        <ValidatorSelect
          textboxMode
          multi
          hiddenMenu
          searchable={false}
          clearable={false}
          disabled={props.disabled || props.readOnly}
          options={props.data}
          valueKey={props.valueField}
          labelKey={props.textField}
          value={props.value}
          field={props.field}
          group={props.group}
          onChange={props.onChange}
          validations={props.validations}
        />
        <a>
          <span
            onClick={!props.readOnly && this.openRolePopup}
            className="icon-plus"
            title={localization.getText('USER_LABEL_SELECT_USER')}
          />
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/User/Izenda.RoleLookUp.js